import { useHistory, useLocation } from 'react-router-dom';

type BulkUploadPanelType = 'GOALS' | 'OBJECTIVES';

export const useOKRBulkUploadPanel = ({ panelType }: { panelType: BulkUploadPanelType }) => {
  const history = useHistory();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  const bulkUploadPanelType = queryParams.get('okrBulkUploadType') as BulkUploadPanelType;

  const isBulkUploadPanelOpen = queryParams.get('okrBulkUploadPanel') === 'true' && bulkUploadPanelType === panelType;

  const openBulkUploadPanel = () => {
    queryParams.set('okrBulkUploadPanel', 'true');
    queryParams.set('okrBulkUploadType', panelType);
    history.push({
      search: queryParams.toString(),
    });
  };

  const closeBulkUploadPanel = () => {
    queryParams.delete('okrBulkUploadPanel');
    queryParams.delete('okrBulkUploadType');
    history.push({
      search: queryParams.toString(),
    });
  };

  return { isOpen: isBulkUploadPanelOpen, panelType: bulkUploadPanelType, openBulkUploadPanel, closeBulkUploadPanel };
};
